export default {"src":"/_next/static/media/Call--icon-Phone--Streamline-Core.ae13ac67.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};